import React from 'react'
import { Field, ErrorMessage } from 'formik'
import formatISO from 'date-fns/formatISO'
import { DatepickerTextField } from 'components/Zui'
import FieldError from './FieldError'

export const Datepicker = props => {
    return (
        <div className="input-wrapper-column">
            {!props.noLabel && (
                <div className="form-label">
                    <span>{props.label || props.name}</span>
                </div>
            )}
            <Field component={DatepickerComponent} {...props} />
            <ErrorMessage name={props.name} component={FieldError} />
        </div>
    )
}

const DatepickerComponent = ({ field, form, children, options, ...props }) => {
    const { onBlur, onChange, value, ...fieldProps } = field
    const { error } = form.getFieldMeta(field.name)
    const { setFieldTouched, setFieldValue } = form

    if (error) {
        props = { ...props, warningInvalid: Boolean(error), invalid: true }
    }

    return (
        <DatepickerTextField
            {...fieldProps}
            value={value ? new Date(value) : null}
            closeOnDateSelected
            onTextfieldDatePickerDateSelected={({ target }) => {
                setFieldValue(field.name, formatISO(target.value) || null)
                setFieldTouched(field.name, true)
            }}
            {...props}
        ></DatepickerTextField>
    )
}
